module.exports = {"errorRequired":"This field is required.","errorInvalid":"The format is invalid.","urlAlreadyExist":"This URL already exists. Please use another one."}


//////////////////
// WEBPACK FOOTER
// ./src/components/Videos/locales/fr.json
// module id = 1779
// module chunks = 0